module.exports = __webpack_public_path__ + "img/diving.a1faf0e8.svg";